import React, { useState, useRef, useEffect } from 'react';
import Modal from '../../common/components/Modal/modal';
import AssignRmModalField from './AssignRmModalField';
import PhoneInTalkIcon from '@material-ui/icons/PhoneInTalk';
import { GetAllRmList } from '../../common/constants/api';
import moment from 'moment';
import { numberFormat } from '../../common/constants/NumberFormat';
import { getAcl } from '../../common/utils/acl-utils';
import { navigate } from 'gatsby';
import { FromDateRange, toDateRange } from '../AdminDashboard/AdminDashboard';
import { getFiltersInfo, setFiltersInfo } from '../../common/utils/FiltersInfo';

export const ShowModal = ({ show, setshow, row, getPartnerList, rmList }) => {
  return (
    <div className="w-full" key={row.id}>
      <Modal show={show} setShow={setshow}>
        <AssignRmModalField
          bpName={`${row?.name?.firstName || ''} ${row?.name?.middleName ||
            ''} ${row?.name?.lastName || ''}`}
          bpCode={row?.partnerCode}
          rmList={rmList || []}
          currRm={
            row?.rmName?.firstName
              ? `${row?.rmName?.firstName || ''} ${row?.rmName?.middleName ||
                  ''} ${row?.rmName?.lastName || ''}`
              : false
          }
          setShow={setshow}
          row={row}
          successUrl={getPartnerList}
        />
      </Modal>
    </div>
  );
};

export const DateFormat = date => {
  if (date && moment(date).isValid()) {
    return (
      moment(date).format('DD-MM-YYYY') + ' ' + moment(date).format('hh:mmA')
    );
  }
  return date;
};

const AssignBPColumn = (rmId, getPartnerList) => {
  const [show, setshow] = useState(false);
  const [modalField, setModalField] = useState('');
  const [assignedRM, setAssignedRM] = useState(new Map());
  const [rmList, setRmList] = useState([]);

  const assignRM = useRef('');
  const modalRef = useRef('');
  useEffect(() => {
    if (!show) {
      setModalField('');
    }
  }, [show]);

  useEffect(() => {
    GetAllRmList().then(res => setRmList(res));
  }, []);
  const goToDashboard = (e, row, selector) => {
    e.stopPropagation();

    if (selector) {
      setFiltersInfo({
        status: selector,
        startDate: FromDateRange(),
        endDate: toDateRange(),
        bpUserId: row.id,
        backPage: 'bp',
        selectedRm: rmId || ''
      });

      navigate(`/app/dashboard`);
    }
  };
  return [
    {
      name: 'Business Partner Name',
      selector: row => {
        return (
          (row.name.firstName
            ? row.name.firstName.toString().toLowerCase() + ' '
            : '') +
          (row.name.middleName
            ? row.name.middleName.toString().toLowerCase() + ' '
            : '') +
          (row.name.lastName ? row.name.lastName.toString().toLowerCase() : '')
        );
      },
      sortable: true,
      cell: row => {
        return (
          <div
            className="text-center font-roboto font-normal mx-auto"
            style={{ whiteSpace: 'break-spaces' }}
          >
            {(row.name.firstName ? row.name.firstName + ' ' : '') +
              (row.name.middleName ? row.name.middleName + ' ' : '') +
              (row.name.lastName ? row.name.lastName : '')}
          </div>
        );
      }
    },
    {
      name: 'Business Partner Code',
      selector: 'partnerCode',
      sortable: true,
      cell: row => (
        <div
          className="text-center font-roboto font-normal mx-auto"
          style={{ whiteSpace: 'break-spaces' }}
        >
          {row.partnerCode ? row.partnerCode : <span>&#8212; </span>}
        </div>
      )
    },
    {
      name: 'Phone',
      selector: 'phone',
      sortable: true,
      cell: row => {
        const [showPhoneNumber, setShowPhoneNumber] = useState(false);
        return (
          <div
            className="text-center font-roboto font-normal mx-auto"
            style={{ whiteSpace: 'break-spaces' }}
          >
            <div
              className="w-full mx-auto text-center"
              onMouseEnter={() => setShowPhoneNumber(true)}
              onMouseLeave={() => setShowPhoneNumber(false)}
              onClick={() => setShowPhoneNumber(true)}
            >
              {row?.phone ? (
                <PhoneInTalkIcon style={{ color: 'rgb(56 169 56)' }} />
              ) : (
                '---'
              )}
            </div>
            {showPhoneNumber && row?.phone && (
              <div
                className="w-full absolute bg-white rounded -ml-4 px-2 py-3 top-0 -mt-6 font-bold rounded shadow text-blue-1101 z-50 "
                style={{ minWidth: '95px' }}
              >
                {row?.phone}
              </div>
            )}
          </div>
        );
      }
    },
    {
      name: 'Enrolment Date',
      selector: 'enrollmentDate',
      sortable: true,
      cell: row => (
        <div
          className="text-center font-roboto font-normal mx-auto"
          style={{ whiteSpace: 'break-spaces' }}
        >
          {DateFormat(row.enrollmentDate) ? (
            DateFormat(row.enrollmentDate)
          ) : (
            <span>&#8212; </span>
          )}
        </div>
      )
    },
    {
      name: 'RM',
      selector: row =>
        assignedRM.get(row.id)
          ? assignedRM.get(row.id)
          : row.rmName.firstName
          ? (row.rmName.firstName ? row.rmName.firstName + ' ' : '') +
            (row.rmName.middleName ? +row.rmName.middleName + ' ' : '') +
            (row.rmName.lastName ? row.rmName.lastName : '')
          : 'Assign RM',

      sortable: true,
      cell: row => {
        const [showRMModal, setShowRmModal] = useState(false);

        return (
          <div
            className="text-center font-roboto font-normal mx-auto"
            style={{ whiteSpace: 'break-spaces' }}
          >
            {getAcl()?.acl?.can_assign_rm ? (
              <React.Fragment>
                {showRMModal && (
                  <ShowModal
                    show={showRMModal}
                    setshow={setShowRmModal}
                    row={row}
                    successCall={getPartnerList}
                    getPartnerList={getPartnerList}
                    rmList={rmList}
                  />
                )}

                {row?.rmName?.firstName ? (
                  <div
                    className="text-blue-600 text-center mx-auto text-xs font-medium cursor-pointer"
                    style={{ whiteSpace: 'break-spaces' }}
                    ref={assignRM}
                    onClick={() => {
                      setShowRmModal(true);
                    }}
                  >
                    {`${row?.rmName?.firstName || ''} ${row?.rmName
                      ?.middleName || ''} ${row?.rmName?.lastName || ''}`}
                  </div>
                ) : (
                  <button
                    className="border border-tealCol-100 mx-auto rounded py-2 px-2 text-xs text-tealCol-100 text-center"
                    onClick={() => {
                      setShowRmModal(true);
                    }}
                  >
                    Assign RM
                  </button>
                )}
              </React.Fragment>
            ) : (
              <div
                className="text-blue-600 text-center mx-auto text-sm "
                style={{ whiteSpace: 'break-spaces' }}
              >
                {row?.rmName?.firstName ? (
                  `${row?.rmName?.firstName || ''} ${row?.rmName?.middleName ||
                    ''} ${row?.rmName?.lastName || ''}`
                ) : (
                  <span className="text-black-0 text-xs">--- </span>
                )}
              </div>
            )}
          </div>
        );
      }
    },

    {
      name: 'City',
      selector: 'city',
      sortable: true,
      cell: row => (
        <div
          className="text-center font-roboto font-normal mx-auto"
          style={{ whiteSpace: 'break-spaces' }}
        >
          {row.city ? row.city : <span>&#8212; </span>}
        </div>
      )
    },
    {
      name: 'Leads ',
      selector: 'leads',
      sortable: true,
      cell: row => (
        <div
          className={`flex justify-center items-center text-center font-roboto font-normal mx-auto rounded-full h-8 w-8 bg-green-200 text-green-600 ${row.leads &&
            'cursor-pointer'}`}
          style={{ whiteSpace: 'break-spaces' }}
          onClick={e => row.leads && goToDashboard(e, row, 'New Lead')}
        >
          {row.leads ? row.leads : 0}
        </div>
      )
    },
    {
      name: 'Logins',
      selector: 'login',
      sortable: true,
      cell: row => (
        <div
          className={`flex justify-center items-center text-center font-roboto font-normal mx-auto rounded-full h-8 w-8 bg-orange-100 text-grey-600 ${row.login &&
            'cursor-pointer'}`}
          style={{ whiteSpace: 'break-spaces' }}
          onClick={e => row.login && goToDashboard(e, row, 'Login')}
        >
          {row.login ? row.login : 0}
        </div>
      )
    },
    {
      name: 'Sanction',
      selector: 'sanction',
      sortable: true,
      cell: row => (
        <div
          className={`flex justify-center items-center text-center font-roboto font-normal mx-auto rounded-full h-8 w-8 bg-lightCyan-100 text-green-600  ${row.sanction &&
            'cursor-pointer'}`}
          style={{ whiteSpace: 'break-spaces' }}
          onClick={e => row.sanction && goToDashboard(e, row, 'Sanctioned')}
        >
          {row.sanction ? row.sanction : 0}
        </div>
      )
    },
    {
      name: 'Disbursement',
      selector: 'disbursed',
      sortable: true,
      cell: row => (
        <div
          className={`flex justify-center items-center text-center font-roboto font-normal mx-auto rounded-full h-8 w-8 bg-purple-200 text-green-600 ${row.disbursed &&
            'cursor-pointer'}`}
          style={{ whiteSpace: 'break-spaces' }}
          onClick={e => row.disbursed && goToDashboard(e, row, 'Disbursed')}
        >
          {row.disbursed ? row.disbursed : 0}
        </div>
      )
    },
    {
      name: 'GR',
      selector: 'gr',
      sortable: true,
      cell: row => (
        <div
          className="text-center font-roboto font-normal mx-auto"
          style={{ whiteSpace: 'break-spaces' }}
        >
          &#8377;{numberFormat(row.gr) ? numberFormat(row.gr) : 0}
        </div>
      )
    },
    {
      name: 'Payout',
      selector: 'payout',
      sortable: true,
      cell: row => (
        <div
          className="text-center font-roboto font-normal mx-auto"
          style={{ whiteSpace: 'break-spaces' }}
        >
          &#8377;{numberFormat(row.payout) ? numberFormat(row.payout) : 0}
        </div>
      )
    },
    {
      name: 'NR',
      selector: 'nr',
      sortable: true,
      cell: row => (
        <div
          className="text-center font-roboto font-normal mx-auto"
          style={{ whiteSpace: 'break-spaces' }}
        >
          {' '}
          &#8377;{numberFormat(row.nr) ? numberFormat(row.nr) : 0}
        </div>
      )
    },
    {
      name: 'Last Action Date',
      selector: 'lastActionDate',
      sortable: true,
      cell: row => (
        <div
          className="text-center font-roboto font-normal mx-auto"
          style={{ whiteSpace: 'break-spaces' }}
        >
          {DateFormat(row.lastActionDate) ? (
            DateFormat(row.lastActionDate)
          ) : (
            <span>&#8212; </span>
          )}
        </div>
      )
    }
  ];
};
export default AssignBPColumn;
